export default "__VITE_ASSET__BBU41YbH__"